(() => {
  const selector = '.template-index .section-header';
  const pinnedClass = 'rilavere-header-pinned';
  let frame = 0;
  let header = null;
  let headerHeight = 0;
  let threshold = 0;

  const measure = () => {
    if (!header) return;
    headerHeight = Math.round(header.getBoundingClientRect().height);
    threshold = headerHeight * 0.5;
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  };

  const update = () => {
    frame = 0;
    if (!header) return;
    header.classList.toggle(pinnedClass, window.scrollY >= threshold);
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  };

  const bindHeader = () => {
    const nextHeader = document.querySelector(selector);
    if (!nextHeader) return;
    header = nextHeader;
    measure();
    update();
  };

  const mount = () => {
    bindHeader();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', () => {
      measure();
      update();
    });
    document.addEventListener('shopify:section:load', () => {
      window.requestAnimationFrame(bindHeader);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
